/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
} from "reactstrap";

import Select from "react-select";

import TextareaAutosize from "react-textarea-autosize";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import { getOptions as getOptionsUtils } from "../../Libs/CrudUtils/crudUtils";
// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import CustomFormRepeater from "../../components/Common/CustomFormRepeater";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import schema from "./ChannelValidation.js";

import {
  getChannel,
  createChannel,
  editChannel,
  resetChannel,
  resetChannels,
  resetError,
} from "../../store/channels/actions";

const NewChannel = ({ t }) => {
  let { idChannel } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit, setValue, errors, setError, clearErrors } =
    useForm({
      resolver: yupResolver(schema),
    });

  const {
    dataChannelGetSet,
    dataChannelEditCreate,
    loadingChannel,
    loadingChannelEditCreate,
    successChannel,
    errorChannel,
  } = useSelector((state) => state.Channel);

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [selectedType, setSelectedType] = useState(null);
  const [selectedExt, setSelectedExt] = useState(null);

  const [channelValues, setChannelValues] = useState({
    name: "",
    nameBk: "",

    key: "",
    keyBk: "",

    skill: "",
    skillBk: "",

    channel: "",
    channelBk: "",

    integrationId: null,
    integrationIdBk: null,

    accessKey: null,
    accessKeyBk: null,

    messageMaxSize: 4096,
    messageMaxSizeBk: 4096,

    supported_files: [
      {
        value: "image",
        maxSize: 10000,
        metric: "KB",
        ext: ["png", "jpeg", "jpg"],
      },
      {
        value: "file",
        maxSize: 10000,
        metric: "KB",
        ext: ["pdf", "doc", "docx", "xls"],
      },
      {
        value: "video",
        maxSize: 10000,
        metric: "KB",
        ext: ["mp4", "avi", "mov", "wmv", "webm", "ogg"],
      },
    ],
    supported_filesBk: [
      {
        value: "image",
        maxSize: 10000,
        metric: "KB",
        ext: ["png", "jpeg", "jpg"],
      },
      {
        value: "file",
        maxSize: 10000,
        metric: "KB",
        ext: ["pdf", "doc", "docx", "xls"],
      },
      {
        value: "video",
        maxSize: 10000,
        metric: "KB",
        ext: ["mp4", "avi", "mov", "wmv", "webm", "ogg"],
      },
    ],

    customInfo: null,
    customInfoBk: null,

    timeout: null,
    timeoutBk: null,

    preSurveyId: "",
    preSurveyIdBk: "",

    posSurveyId: "",
    posSurveyIdBk: "",

    defaultSurveyId: "",
    defaultSurveyIdBk: "",

    npsSurveyId: "",
    npsSurveyIdBk: "",
  });

  const showToast = useCallback(
    (type, message) => {
      toastr[type](message);
    },
    [successChannel]
  );
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successChannel &&
      dispatch(resetChannel()) &&
      dispatch(resetChannels()) &&
      history.push("/channels"),
  };

  const handleCreateEditChannel = () => {
    let value = {};

    newFields?.integrationId
      ? (value = { ...value, integrationId: newFields.integrationId })
      : (value = { ...value, integrationId: channelValues?.integrationId });

    newFields?.accessKey
      ? (value = { ...value, accessKey: newFields.accessKey })
      : (value = { ...value, accessKey: channelValues?.accessKey });

    newFields?.messageMaxSize
      ? (value = {
        ...value,
        config: {
          ...value.config,
          message: {
            maxSize: newFields.messageMaxSize,
            metric: "characters",
          },
        },
      })
      : (value = {
        ...value,
        config: {
          ...value.config,
          message: {
            maxSize: channelValues?.messageMaxSize,
            metric: "characters",
          },
        },
      });

    newFields?.supported_files
      ? (value = {
        ...value,
        supported_files: newFields.supported_files.map((e) => e.value),
        config: {
          ...value.config,
          ...(newFields.supported_files.reduce(
            (acc, cur, i) => ({
              ...acc,
              [cur.value]: {
                maxSize: cur.maxSize,
                metric: cur.metric,
                ext: cur.ext,
              },
            }),
            {}
          ) ?? []),
        },
      })
      : (value = {
        ...value,
        supported_files: channelValues?.supported_files.map((e) => e.value),
        config: {
          ...value.config,
          ...(channelValues?.supported_files.reduce(
            (acc, cur, i) => ({
              ...acc,
              [cur.value]: {
                maxSize: cur.maxSize,
                metric: cur.metric,
                ext: cur.ext,
              },
            }),
            {}
          ) ?? []),
        },
      });

    newFields?.customInfo
      ? (value = {
        ...value,
        ...JSON.parse(newFields.customInfo),
      })
      : channelValues?.customInfo &&
      (value = {
        ...value,
        ...JSON.parse(channelValues.customInfo),
      });

    newFields?.timeout
      ? (value = { ...value, timeout: newFields.timeout })
      : (value = { ...value, timeout: channelValues?.timeout });

    delete newFields.integrationId;
    delete newFields.accessKey;
    delete newFields.messageMaxSize;
    delete newFields.supported_files;
    delete newFields.customInfo;
    delete newFields.timeout;

    if (idChannel) {
      dispatch(editChannel(idChannel, { ...newFields, info: value }));
    } else {
      dispatch(createChannel({ ...newFields, info: value }));
    }
  };

  const newChannelSubmit = () => {
    handleCreateEditChannel();
  };

  const checkValue = (values, valuesBk, target) => {
    if (values === valuesBk) {
      delete newFields[target];
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        [target]: values,
      });
    }
  };
  const isPosChatDisabled = useMemo(() => {
    return (
      channelValues?.channel?.value !== "altu" && channelValues?.channel !== "altu"
    ) && (
      channelValues?.channel?.value !== "tech4humans" && channelValues?.channel !== "tech4humans"
    )
  }, [channelValues?.channel]);

  const checkSupportedFiles = (values, valuesBk) => {
    if (
      JSON.stringify(
        values?.map((e) => ({
          value: e.value,
          ext: e.ext,
          maxSize: e.maxSize,
          metric: e.metric,
        }))
      ) ===
      JSON.stringify(
        valuesBk.map((e) => ({
          value: e.value,
          ext: e.ext,
          maxSize: e.maxSize,
          metric: e.metric,
        }))
      )
    ) {
      delete newFields.supported_files;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        supported_files: values,
      });
    }
  };

  const checkCustomInfos = (values, valuesBk) => {
    if (values === valuesBk) {
      clearErrors("channelinfo");
      delete newFields.customInfo;
    } else {
      try {
        JSON.parse(values);
        clearErrors("channelinfo");
        setNewFields({
          ...newFields,
          customInfo: values,
        });
      } catch (e) {
        delete newFields.customInfo;
        setError("channelinfo", {
          type: "manual",
          message: "JSON Invalid",
        });
      }
    }
    checkSubmit();
  };

  const getOptions = (target, value, label) => {
    let response = [];

    if (dataChannelGetSet?.data?.form[target]?.length > 0) {
      dataChannelGetSet.data.form[target].map((op) =>
        response.push({
          key: op[value],
          value: op[value],
          label: op[label],
        })
      );
    } else {
      if (loadingChannel) {
        response.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        response.push({
          value: "none",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return response;
  };

  const optionsType = (alreadyAdd) => {
    let supportedfiles = [];

    if (dataChannelGetSet?.data?.form?.supported_files?.length > 0) {
      dataChannelGetSet.data.form.supported_files.forEach((file, key) =>
        supportedfiles.push({
          key: key,
          value: file?.value,
          label: file?.type.toUpperCase(),
        })
      );
    } else {
      if (loadingChannel) {
        supportedfiles.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        supportedfiles.push({
          value: "none",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    //Remove this conditional to permmit add multiple questions of same type
    if (Array.isArray(alreadyAdd)) {
      supportedfiles = supportedfiles.filter(
        (n) => !alreadyAdd.includes(n.value)
      );
    }
    return supportedfiles;
  };

  const optionsExt = (selectedOption) => {
    let supportedexts = [];

    if (
      dataChannelGetSet?.data?.form?.supported_files?.length > 0 &&
      selectedOption
    ) {
      dataChannelGetSet.data.form.supported_files
        .find((e) => e.value === selectedOption)
        ?.ext.forEach((ext, key) =>
          supportedexts.push({
            key: key,
            value: ext,
            label: ext.toUpperCase(),
          })
        );
    } else {
      if (loadingChannel) {
        supportedexts.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        supportedexts.push({
          value: "none",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return supportedexts;
  };

  const optionsMetric = () => {
    let metrics = [];

    let dataChannelGetSet = { data: { form: { metrics: ["KB", "MB", "GB"] } } };

    if (dataChannelGetSet?.data?.form?.metrics?.length > 0) {
      dataChannelGetSet.data.form.metrics.forEach((metric, key) =>
        metrics.push({
          key: key,
          value: metric,
          label: metric.toUpperCase(),
        })
      );
    } else {
      if (loadingChannel) {
        metrics.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        metrics.push({
          value: "none",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return metrics;
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length > 0 && !errors.channelinfo?.message) {
      setEnableSubmit(true);
    } else {
      setEnableSubmit(false);
    }
  };

  useEffect(() => {
    if (idChannel) {
      dispatch(getChannel(idChannel, true));
    } else {
      dispatch(getChannel(null, true));
    }
  }, []);

  useEffect(() => {
    if (idChannel && dataChannelGetSet?.data?.source && !loadingChannel) {
      setValue("channelskill", dataChannelGetSet.data.source.skill_id);
      setValue("channelchannel", dataChannelGetSet.data.source.channel);
      let objConfig = { ...dataChannelGetSet.data.source.info.config };
      delete objConfig.message;

      let objInfo = { ...dataChannelGetSet.data.source.info };
      delete objInfo.accessKey;
      delete objInfo.integrationId;
      delete objInfo.supported_files;
      delete objInfo.config;
      delete objInfo.timeout;

      setChannelValues({
        ...channelValues,
        name: dataChannelGetSet.data.source?.name,
        nameBk: dataChannelGetSet.data.source?.name,

        key: dataChannelGetSet.data.source?.key,
        keyBk: dataChannelGetSet.data.source?.key,

        skill_id: dataChannelGetSet.data.source?.skill_id,
        skill_idBk: dataChannelGetSet.data.source?.skill_id,

        channel: dataChannelGetSet.data.source?.channel,
        channelBk: dataChannelGetSet.data.source?.channel,

        integrationId: dataChannelGetSet.data.source?.info?.integrationId,
        integrationIdBk: dataChannelGetSet.data.source?.info?.integrationId,

        accessKey: dataChannelGetSet.data.source?.info?.accessKey,
        accessKeyBk: dataChannelGetSet.data.source?.info?.accessKey,

        messageMaxSize:
          dataChannelGetSet.data.source?.info?.config?.message?.maxSize,
        messageMaxSizeBk:
          dataChannelGetSet.data.source?.info?.config?.message?.maxSize,

        supported_files:
          Object.entries(objConfig)?.length > 0
            ? Object.entries(objConfig).map((item, key) => ({
              key: key,
              value: item[0],
              ext: item[1]?.ext,
              maxSize: item[1]?.maxSize,
              metric: item[1]?.metric,
            }))
            : [],
        supported_filesBk:
          Object.entries(objConfig)?.length > 0
            ? Object.entries(objConfig).map((item, key) => ({
              key: key,
              value: item[0],
              ext: item[1]?.ext,
              maxSize: item[1]?.maxSize,
              metric: item[1]?.metric,
            }))
            : [],

        customInfo: JSON.stringify(objInfo, undefined, 4),
        customInfoBk: JSON.stringify(objInfo, undefined, 4),

        timeout: dataChannelGetSet.data.source?.info?.timeout,
        timeoutBk: dataChannelGetSet.data.source?.info?.timeout,

        preSurveyId: dataChannelGetSet.data.source?.preSurveyId,
        preSurveyIdBk: dataChannelGetSet.data.source?.preSurveyId,

        posSurveyId: dataChannelGetSet.data.source?.posSurveyId,
        posSurveyIdBk: dataChannelGetSet.data.source?.posSurveyId,

        defaultSurveyId: dataChannelGetSet.data.source?.defaultSurveyId,
        defaultSurveyIdBk: dataChannelGetSet.data.source?.defaultSurveyId,

        npsSurveyId: dataChannelGetSet.data.source?.npsSurveyId,
        npsSurveyIdBk: dataChannelGetSet.data.source?.npsSurveyIdBk,
      });
    }
  }, [dataChannelGetSet]);

  useEffect(() => {
    if (dataChannelEditCreate && dataChannelEditCreate.message) {
      showToast("success", t(dataChannelEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successChannel]);

  useEffect(() => {
    if (errorChannel && typeof errorChannel === "object") {
      errorChannel.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorChannel) {
        showToast("error", t(errorChannel));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorChannel]);

  useEffect(() => {
    checkSubmit();
  }, [newFields]);

  const setClassName = (errors, classname) => {
    return errors ? "av-invalid is-invalid " + classname : classname;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/channels"
            path={"/channel"}
            title={t("Channels")}
            breadcrumbItem={idChannel ? t("Edit Channel") : t("Create channel")}
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit(newChannelSubmit)}>
                    <Row className="mb-3">
                      <Col md="12">
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="channel-name-label">
                                {t("Name") + " *"}
                              </Label>
                              <input
                                type="text"
                                name="channelname"
                                ref={register}
                                className={setClassName(
                                  errors.channelname,
                                  "form-control"
                                )}
                                placeholder={t("Enter channel name")}
                                onChange={(e) => {
                                  setChannelValues({
                                    ...channelValues,
                                    name: e.target.value,
                                  });
                                  checkValue(
                                    e.target.value,
                                    channelValues.nameBk,
                                    "name"
                                  );
                                }}
                                value={channelValues?.name ?? ""}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.channelname?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="channel-key-label">
                                {t("Key") + " *"}
                              </Label>
                              <input
                                type="text"
                                name="channelkey"
                                ref={register}
                                className={setClassName(
                                  errors.channelkey,
                                  "form-control"
                                )}
                                placeholder={t("Enter channel key")}
                                onChange={(e) => {
                                  setChannelValues({
                                    ...channelValues,
                                    key: e.target.value,
                                  });
                                  checkValue(
                                    e.target.value,
                                    channelValues.keyBk,
                                    "key"
                                  );
                                }}
                                value={channelValues?.key ?? ""}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.channelkey?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label id="channels-skill">
                                {t("Skill") + " *"}
                              </Label>
                              <Select
                                id="channelskill"
                                name="channelskill"
                                ref={() => register({ name: "channelskill" })}
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.channelskill,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={getOptionsUtils(
                                  dataChannelGetSet?.data?.form?.skills,
                                  loadingChannel
                                )}
                                onChange={(e) => {
                                  setValue("channelskill", e.value);
                                  setChannelValues({
                                    ...channelValues,
                                    skill_id: e,
                                  });
                                  checkValue(
                                    e.value,
                                    channelValues.skill_idBk,
                                    "skill_id"
                                  );
                                }}
                                value={getOptionsUtils(
                                  dataChannelGetSet?.data?.form?.skills,
                                  loadingChannel
                                ).find(
                                  (item) =>
                                    item.value === channelValues.skill_id
                                )}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.channelskill?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label id="channels-channel">
                                {t("Channel") + " *"}
                              </Label>
                              <Select
                                id="channelchannel"
                                name="channelchannel"
                                ref={() => register({ name: "channelchannel" })}
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.channelchannel,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={getOptions(
                                  "channels",
                                  "value",
                                  "type"
                                )}
                                onChange={(e) => {
                                  setValue("channelchannel", e.value);
                                  if (e.value !== "Altu") {
                                    setChannelValues({
                                      ...channelValues,
                                      channel: e,
                                      posSurveyId: null,
                                    });
                                  } else {
                                    setChannelValues({
                                      ...channelValues,
                                      channel: e,
                                    });
                                  }
                                  checkValue(
                                    e.value,
                                    channelValues.channelBk,
                                    "channel"
                                  );
                                }}
                                value={getOptions(
                                  "channels",
                                  "value",
                                  "type"
                                ).find(
                                  (item) => item.value === channelValues.channel
                                )}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.channelchannel?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label>{t("Pre chat survey")}</Label>
                              <Select
                                ref={() =>
                                  register({ name: "channelpresurvey" })
                                }
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.channelpresurvey,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={getOptionsUtils(
                                  [
                                    { id: "none", name: t("None") },
                                    ...(dataChannelGetSet?.data?.form
                                      ?.preSurveys ?? []),
                                  ],
                                  loadingChannel
                                )}
                                onChange={(e) => {
                                  const value =
                                    e.value === "none" ? null : e.value;
                                  setValue("channelpresurvey", value);
                                  setChannelValues({
                                    ...channelValues,
                                    preSurveyId: value,
                                  });
                                  checkValue(
                                    value,
                                    channelValues.preSurveyIdBk,
                                    "preSurveyId"
                                  );
                                }}
                                value={getOptionsUtils(
                                  [
                                    { id: "none", name: t("None") },
                                    ...(dataChannelGetSet?.data?.form
                                      ?.preSurveys ?? []),
                                  ],
                                  loadingChannel
                                ).find((item) =>
                                  channelValues.preSurveyId
                                    ? item.value === channelValues.preSurveyId
                                    : item.value === "none"
                                )}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.channelpresurvey?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label>{t("Pos chat survey")}</Label>
                              <Select
                                ref={() =>
                                  register({ name: "channelpossurvey" })
                                }
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.channelpossurvey,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={getOptionsUtils(
                                  [
                                    { id: "none", name: t("None") },
                                    ...(dataChannelGetSet?.data?.form
                                      ?.posSurveys ?? []),
                                  ],
                                  loadingChannel
                                )}
                                onChange={(e) => {
                                  const value =
                                    e.value === "none" ? null : e.value;
                                  setValue("channelpossurvey", value);
                                  setChannelValues({
                                    ...channelValues,
                                    posSurveyId: value,
                                  });
                                  checkValue(
                                    value,
                                    channelValues.posSurveyIdBk,
                                    "posSurveyId"
                                  );
                                }}
                                value={getOptionsUtils(
                                  [
                                    { id: "none", name: t("None") },
                                    ...(dataChannelGetSet?.data?.form
                                      ?.posSurveys ?? []),
                                  ],
                                  loadingChannel
                                ).find((item) =>
                                  channelValues.posSurveyId
                                    ? item.value === channelValues.posSurveyId
                                    : item.value === "none"
                                )}
                                isDisabled={isPosChatDisabled}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.channelpossurvey?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label>{t("NPS survey")}</Label>
                              <Select
                                ref={() =>
                                  register({ name: "channelnpssurvey" })
                                }
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.channelnpssurvey,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={getOptionsUtils(
                                  [
                                    { id: "none", name: t("None") },
                                    ...(dataChannelGetSet?.data?.form
                                      ?.npsSurveys ?? []),
                                  ],
                                  loadingChannel
                                )}
                                onChange={(e) => {
                                  const value =
                                    e.value === "none" ? null : e.value;
                                  setValue("channelnpssurvey", value);
                                  setChannelValues({
                                    ...channelValues,
                                    npsSurveyId: value,
                                  });
                                  checkValue(
                                    value,
                                    channelValues.npsSurveyIdBk,
                                    "npsSurveyId"
                                  );
                                }}
                                value={getOptionsUtils(
                                  [
                                    { id: "none", name: t("None") },
                                    ...(dataChannelGetSet?.data?.form
                                      ?.npsSurveys ?? []),
                                  ],
                                  loadingChannel
                                ).find((item) =>
                                  channelValues.npsSurveyId
                                    ? item.value === channelValues.npsSurveyId
                                    : item.value === "none"
                                )}
                                isDisabled={isPosChatDisabled}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.channelnpssurvey?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label>{t("Default survey")}</Label>
                              <Select
                                ref={() =>
                                  register({ name: "channeldefaultsurvey" })
                                }
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.channeldefaultsurvey,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={getOptionsUtils(
                                  [
                                    { id: "none", name: t("None") },
                                    ...(dataChannelGetSet?.data?.form
                                      ?.defaultSurveys ?? []),
                                  ],
                                  loadingChannel
                                )}
                                onChange={(e) => {
                                  const value =
                                    e.value === "none" ? null : e.value;
                                  setValue("channeldefaultsurvey", value);
                                  setChannelValues({
                                    ...channelValues,
                                    defaultSurveyId: value,
                                  });
                                  checkValue(
                                    value,
                                    channelValues.defaultSurveyIdBk,
                                    "defaultSurveyId"
                                  );
                                }}
                                value={getOptionsUtils(
                                  [
                                    { id: "none", name: t("None") },
                                    ...(dataChannelGetSet?.data?.form
                                      ?.defaultSurveys ?? []),
                                  ],
                                  loadingChannel
                                ).find((item) =>
                                  channelValues.defaultSurveyId
                                    ? item.value === channelValues.defaultSurveyId
                                    : item.value === "none"
                                )}
                                isDisabled={isPosChatDisabled}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.channeldefaultsurvey?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="channel-name-label">
                                {t(
                                  "Customer first response timeout when reopening conversation"
                                )}
                              </Label>
                              <input
                                type="number"
                                name="channeltimeout"
                                ref={register}
                                className={setClassName(
                                  errors.channeltimeout,
                                  "form-control"
                                )}
                                placeholder={t("Enter timeout in minutes")}
                                onChange={(e) => {
                                  setChannelValues({
                                    ...channelValues,
                                    timeout: e.target.value,
                                  });
                                  checkValue(
                                    e.target.value,
                                    channelValues.timeoutBk,
                                    "timeout"
                                  );
                                }}
                                value={channelValues?.timeout ?? ""}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.channeltimeout?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="channel-integrationid-label">
                                {t("Integration Id")}
                              </Label>
                              <input
                                type="text"
                                name="channelintegrationid"
                                ref={register}
                                className="form-control"
                                placeholder={t("Enter channel integration id")}
                                onChange={(e) => {
                                  const value =
                                    e.target.value !== ""
                                      ? e.target.value
                                      : null;
                                  setChannelValues({
                                    ...channelValues,
                                    integrationId: value,
                                  });
                                  checkValue(
                                    value,
                                    channelValues.integrationIdBk,
                                    "integrationId"
                                  );
                                }}
                                value={channelValues?.integrationId ?? ""}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.channelintegrationid?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="channel-accesskey-label">
                                {t("Access Key")}
                              </Label>
                              <input
                                type="text"
                                name="channelaccesskey"
                                className="form-control"
                                placeholder={t("Enter channel access key")}
                                onChange={(e) => {
                                  const value =
                                    e.target.value !== ""
                                      ? e.target.value
                                      : null;
                                  setChannelValues({
                                    ...channelValues,
                                    accessKey: value,
                                  });
                                  checkValue(
                                    value,
                                    channelValues.accessKeyBk,
                                    "accessKey"
                                  );
                                }}
                                value={channelValues?.accessKey ?? ""}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="channel-messagemaxsize-label">
                                {t("Message Maximum Size (characters)")}
                              </Label>
                              <input
                                type="text"
                                name="channelmessagemaxsize"
                                className="form-control"
                                placeholder={t(
                                  "Enter channel message maximum size"
                                )}
                                onChange={(e) => {
                                  const value =
                                    e.target.value !== ""
                                      ? e.target.value
                                      : null;
                                  setChannelValues({
                                    ...channelValues,
                                    messageMaxSize: value,
                                  });
                                  checkValue(
                                    value,
                                    channelValues.messageMaxSizeBk,
                                    "messageMaxSize"
                                  );
                                }}
                                value={channelValues?.messageMaxSize ?? ""}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="channels-supported_files">
                                {t("Supported Files")}
                              </Label>
                              <CustomFormRepeater
                                inputRowProps={{ className: "d-flex" }}
                                outputRowProps={{ className: "d-flex" }}
                                buttonColProps={{
                                  className: "mb-3 mt-auto",
                                  sm: 3,
                                }}
                                errorText={t("Fill all fields")}
                                addButtonText={t("Add")}
                                addButtonProps={{
                                  type: "button",
                                  color: "success",
                                  className:
                                    "waves-effect waves-light w-100 mr-2",
                                }}
                                deleteButtonText={t("Delete")}
                                deleteButtonProps={{
                                  type: "button",
                                  color: "danger",
                                  className:
                                    "waves-effect waves-light w-100 mr-2",
                                }}
                                outputProps={{
                                  className: "form-control",
                                  type: "text",
                                }}
                                fields={[
                                  {
                                    label: t("Type"),
                                    name: "value",
                                    select: true,
                                    inputProps: {
                                      className: "select2-container",
                                      classNamePrefix: "select2-selection",
                                      placeholder: t("Choose") + "...",
                                      options: optionsType(
                                        channelValues.supported_files.map(
                                          (e) => e.value
                                        )
                                      ),
                                    },
                                    colProps: { className: "mb-3", sm: 2 },
                                    labelProps: {
                                      className: "font-weight-light",
                                    },
                                  },
                                  {
                                    label: t("Extension"),
                                    name: "ext",
                                    select: true,
                                    inputProps: {
                                      className: "select2-container",
                                      classNamePrefix: "select2-selection",
                                      placeholder: t("Choose") + "...",
                                      options: optionsExt(selectedType),
                                      value: selectedExt,
                                      isMulti: true,
                                      isClearable: false,
                                    },
                                    colProps: { className: "mb-3", sm: 5 },
                                    labelProps: {
                                      className: "font-weight-light",
                                    },
                                  },
                                  {
                                    label: t("Max Size"),
                                    name: "maxSize",
                                    colProps: { className: "mb-3", sm: 3 },
                                    labelProps: {
                                      className: "font-weight-light",
                                    },
                                    inputProps: {
                                      className: "form-control",
                                      placeholder:
                                        t("Enter maximum size") + "...",
                                      type: "number",
                                    },
                                  },
                                  {
                                    label: t("Metric"),
                                    name: "metric",
                                    select: true,
                                    inputProps: {
                                      className: "select2-container",
                                      classNamePrefix: "select2-selection",
                                      placeholder: t("Choose") + "...",
                                      options: optionsMetric(),
                                      isDisabled: !selectedExt,
                                    },
                                    colProps: { className: "mb-3", sm: 2 },
                                    labelProps: {
                                      className: "font-weight-light",
                                    },
                                  },
                                ]}
                                value={channelValues.supported_files}
                                onChange={(e) => {
                                  setSelectedType(null);
                                  setSelectedExt(null);
                                  setChannelValues({
                                    ...channelValues,
                                    supported_files: e,
                                  });
                                  checkSupportedFiles(
                                    e,
                                    channelValues.supported_filesBk
                                  );
                                }}
                                onChangeSelect={(e) => {
                                  setSelectedType(e?.value?.value);
                                  e?.value?.value !== selectedType
                                    ? setSelectedExt(null)
                                    : setSelectedExt(e?.ext);
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="channel-name-label">
                                {t("Custom Infos (JSON)")}
                              </Label>
                              <div className="textarea-container">
                                <TextareaAutosize
                                  type="textarea"
                                  className={setClassName(
                                    errors.channelinfo,
                                    "form-control"
                                  )}
                                  placeholder={t("Enter channel infos")}
                                  onChange={(e) => {
                                    const value =
                                      e.target.value !== ""
                                        ? e.target.value
                                        : null;
                                    setChannelValues({
                                      ...channelValues,
                                      customInfo: value,
                                    });
                                    checkCustomInfos(
                                      value,
                                      channelValues.customInfoBk
                                    );
                                  }}
                                  height="200px"
                                  value={channelValues?.customInfo ?? ""}
                                />
                                <div id="textCopy"></div>
                              </div>
                              <div className="invalid-feedback d-block">
                                {t(errors.channelinfo?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingChannelEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/channels">
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect btn-dark"
                        onClick={() => dispatch(resetChannel())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewChannel);
